import { defineComponent as f, computed as s, openBlock as r, createElementBlock as l, normalizeClass as a, createElementVNode as m, renderSlot as c, Fragment as g, toDisplayString as n, createCommentVNode as o } from "vue";
const _ = { class: "list-item-text__left" }, x = { class: "list-item-text__right" }, S = /* @__PURE__ */ f({
  __name: "BaseListItemText",
  props: {
    primary: {},
    secondary: { default: void 0 },
    rightPrimary: { default: void 0 },
    rightSecondary: { default: void 0 },
    inset: { type: Boolean, default: !1 },
    multiline: { type: Boolean, default: !1 },
    noWrap: { type: Boolean, default: !1 }
  },
  setup(i) {
    const e = i, u = s(() => {
      const t = ["list-item-text"];
      return e.inset && t.push("list-item-text--inset"), e.multiline && t.push("list-item-text--multiline"), e.noWrap && t.push("list-item-text--no-wrap"), (e.rightPrimary || e.rightSecondary) && t.push("list-item-text--with-right"), t.join(" ");
    }), d = s(() => {
      const t = ["list-item-text__primary"];
      return e.multiline && t.push("list-item-text__primary--multiline"), e.noWrap && t.push("list-item-text__primary--no-wrap"), t.join(" ");
    }), y = s(() => {
      const t = ["list-item-text__secondary"];
      return e.multiline && t.push("list-item-text__secondary--multiline"), e.noWrap && t.push("list-item-text__secondary--no-wrap"), t.join(" ");
    }), h = s(() => {
      const t = ["list-item-text__right-primary"];
      return e.multiline && t.push("list-item-text__right-primary--multiline"), e.noWrap && t.push("list-item-text__right-primary--no-wrap"), t.join(" ");
    }), p = s(() => {
      const t = ["list-item-text__right-secondary"];
      return e.multiline && t.push("list-item-text__right-secondary--multiline"), e.noWrap && t.push("list-item-text__right-secondary--no-wrap"), t.join(" ");
    });
    return (t, v) => (r(), l("div", {
      class: a(u.value)
    }, [
      m("div", _, [
        c(t.$slots, "left"),
        t.$slots.left ? o("", !0) : (r(), l(g, { key: 0 }, [
          m("div", {
            class: a(d.value)
          }, n(i.primary), 3),
          i.secondary ? (r(), l("div", {
            key: 0,
            class: a(y.value)
          }, n(i.secondary), 3)) : o("", !0)
        ], 64))
      ]),
      m("div", x, [
        c(t.$slots, "right"),
        i.rightPrimary ? (r(), l("div", {
          key: 0,
          class: a(h.value)
        }, n(i.rightPrimary), 3)) : o("", !0),
        i.rightSecondary ? (r(), l("div", {
          key: 1,
          class: a(p.value)
        }, n(i.rightSecondary), 3)) : o("", !0)
      ])
    ], 2));
  }
});
export {
  S as default
};
